import { goTo } from 'core/api/actions/navigation';
import { getQueryParams, normalizeRoute } from 'core/api/utils';

import { onrampSequenceForUser, ROUTE_MAP } from 'onramp/api/routeSequence';

const findRouteIndex = (routes, pathname = window.location.pathname) => {
  const normalizedPath = normalizeRoute(pathname);
  return routes.findIndex((route) => route.path === normalizedPath);
};

const findRoute = (routes, offset = 0) => routes[findRouteIndex(routes) + offset];

export const nextStep = (user, cache) => {
  const routes = onrampSequenceForUser(user, cache);
  return findRoute(routes, 1);
};

export const previousStep = (user, cache) => {
  const routes = onrampSequenceForUser(user, cache);
  return findRoute(routes, -1);
};

export const onrampNext = (user, cache, qparams = '') => {
  const { next } = getQueryParams();
  if (next) {

    return goTo(ROUTE_MAP[next].path + qparams);
  }

  const route = nextStep(user, cache);
  const path = (route && route.path) || '/';
  return goTo(path + qparams);
};

export const onrampBack = (user, cache) => {
  const route = previousStep(user, cache);
  const path = (route && route.path) || '/';
  return goTo(path);
};
export const initOrderPath = () => ROUTE_MAP.initOrder.path;
export const prepaidConfirmationPath = () => ROUTE_MAP.prepaidConfirmation.path;
export const orderManagementPath = () => ROUTE_MAP.orderManagement.path;

export const productDescriptionPath = (deliveryDayId, componentId) => {
  return `/onramp/${deliveryDayId}/product-description/${componentId}`;
};

export const editWeekMenuPath = (deliveryDayId) => {
  return `/onramp/edit-week-menu/${deliveryDayId}`;
};

export const selectMealPath = (componentId, deliveryDayId) => {
  return `/onramp/select-meal/${deliveryDayId}/${componentId}`;
};

export const confirmationPath = (invoiceId) => {
  return `/onramp/confirmation/${invoiceId}`;
};

export const myOrderPath = () => ROUTE_MAP.myOrder.path;
export const myProgramPath = () => ROUTE_MAP.myProgram.path;
export const mySettingsPath = () => ROUTE_MAP.mySettings.path;
export const orderHistoryPath = () => ROUTE_MAP.orderHistory.path;
export const invoicesPath = () => ROUTE_MAP.myInvoices.path;

export const resetPasswordPath = (token) => {
  return `/reset-password/${token}`;
};
